module.exports = __webpack_public_path__ + "static/media/add.99221148.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/svg/add.svg
// module id = 1082
// module chunks = 1